import React from "react";
import { TextField, Stack } from '@mui/material';
import "./FractalApp.css";

class ColourOptions extends React.Component {
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.props.onColourChange({ ...this.props, [name]: parseFloat(value) });
  };

  render() {
    const { cycle, exponent, redOffset, greenOffset, blueOffset } = this.props;

    return (
      <Stack spacing = {1}>
		<TextField
			label="Colour cycle length"
            name="cycle"
			type="number"
			size="small"
			margin="dense"
            value={cycle}
			inputProps={{
				onChange:this.handleInputChange,
				step:"0.1",
				min:"0",
				max:"50"
			}}           
          />
		<TextField
			label="Exponent"
            name="exponent"
			type="number"
			size="small"
			margin="dense"
            value={exponent}
			inputProps={{
				onChange:this.handleInputChange,
				step:"0.5",
				min:"0",
				max:"50"
			}}           
          />
		<TextField
			label="Red Offset"
            name="redOffset"
			type="number"
			size="small"
			margin="dense"
            value={redOffset}
			inputProps={{
				onChange:this.handleInputChange,
				step:"0.1",
				min:"0",
				max:"100"
			}}           
          />
		<TextField
			label="Green Offset"
            name="greenOffset"
			type="number"
			size="small"
			margin="dense"
            value={greenOffset}
			inputProps={{
				onChange:this.handleInputChange,
				step:"0.1",
				min:"0",
				max:"100"
			}}           
          />
		<TextField
			label="Blue Offset"
            name="blueOffset"
			type="number"
			size="small"
			margin="dense"
            value={blueOffset}
			inputProps={{
				onChange:this.handleInputChange,
				step:"0.1",
				min:"0",
				max:"100"
			}}           
          />
      </Stack>
    );
  }
}

export default ColourOptions;